"use client";
import { useState } from "react";
import RulesDialog from "@/components/rulesDialog";
import ReservationDialog from "@/components/reservationDialog";
import style from "./reservationBtns.module.scss";
import { JDILogin } from "@/lib/jdiClientUtils";
import cookieUtils from "@/utils/cookieUtils";
import { useTranslation } from "@/i18n/client";
import { sendClickTrack } from '@/tracks/25208'
interface Props {
  offsetTop: number;
  reserveTotal: number;
  currencySymbol: string;
}
const ReservationBtns = ({ offsetTop, reserveTotal, currencySymbol }: Props) => {
  const [openRulesDialog, setOpenRulesDialog] = useState(false);
  const [openReservationDialog, setOpenReservationDialog] = useState(false);
  const { t } = useTranslation();

  //打开规则模态框
  const openRules = () => {
    sendClickTrack.Activity_FlashSales_Rule();
    setOpenRulesDialog(true);
  };
  //打开预约模态框
  const openReservation = async () => {
    const { isLoggedIn } = await JDILogin.getInstance().getUserInfo();
    if (!!isLoggedIn) {
      setOpenReservationDialog(true);
    } else {
      JDILogin.getInstance().openLoginDialog();
    }
  };
  return (
    <>
      <div className={style.reservationBtns} style={{ top: offsetTop }}>
        <span className={style.reservation} onClick={() => openReservation()}>
          {reserveTotal ? `${reserveTotal > 1 ? t("flashSales.reservations") : t("flashSales.reservation")}(${reserveTotal})` : t("flashSales.reservation")}
        </span>
        <span className={style.reservation} onClick={() => openRules()}>
          {t("flashSales.rules")}
        </span>
      </div>
      <RulesDialog open={openRulesDialog} closeFn={() => setOpenRulesDialog(false)} />
      <ReservationDialog open={openReservationDialog} closeFn={() => setOpenReservationDialog(false)} reserveTotal={reserveTotal} currencySymbol={currencySymbol} />
    </>
  );
};

export default ReservationBtns;
